import { msg } from 'gt-react';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { Action, Subject } from '@erp/authz';
import { ProductModule } from '@erp/shared-types';
import { Route as pathlessAuthenticatedRoute } from '../../../route';
import { requirePermission, requireModules } from '../../../route';

const CheckDepositDetailPage = lazyRouteComponent(() =>
  import('./CheckDepositDetailPage').then((module) => ({
    default: module.CheckDepositDetailPage,
  })),
);

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/accounts-receivable/check-deposits/$depositId',
  component: CheckDepositDetailPage,
  loader: () => ({
    crumb: msg('Deposit', { context: 'page breadcrumb, one check deposit' }),
    crumbAncestors: [
      {
        title: msg('Check Deposits', { context: 'page breadcrumb' }),
        path: '/accounts-receivable/check-deposits',
      },
    ],
  }),
  beforeLoad: async ({ context }) => {
    requireModules({ context, oneOf: [ProductModule.AR_INVOICING] });
    await requirePermission({
      context,
      action: Action.Read,
      subject: Subject.ARCash,
    });
  },
});
